
<div class="edit-page-root-container custom-menu-edit-root-container">
    <div class="page-content">
        <!-- Page Header -->
        <div class="page-header">
            <div class="page-title">
                <img class="icon" src="assets/images/menu/svg/custom-menu.svg" width="30" height="30">
                <span class="title">Custom Menu</span>
            </div>
            <div class="page-actions">
                <button mat-button color="primary" class="btn-menu-item" (click)="navigateToMenuItem()">Menu
                    Item</button>
            </div>
            <!-- Navigation Buttons -->
            <div class="action-btn-container">
                <button mat-flat-button class="action-btn btn-discard" (click)="resetToDefault()">
                    DISCARD
                </button>
                <button mat-flat-button class="action-btn btn-save" (click)="saveChanges()">SAVE</button>

            </div>
        </div>

        <!-- Page Details -->
        <div class="page-details">
            <!-- Main Content Section -->
            <div class="detail-section general-settings">
                <div class="content-container">
                    <!-- Menu Settings Content -->
                    <div class="system-content">
                        <div class="menu-item-row" *ngFor="let item of menuItems; let i = index; trackBy: trackByKey">
                            <!-- Checkbox Items -->
                            <ng-container *ngIf="item.type === 'checkbox'">
                                <div class="checkbox-container">
                                    <mat-checkbox [checked]="getSettingValue(item.key)"
                                        (change)="onSettingChange({key: item.key, value: $event.checked})">
                                        {{ item.label }}
                                    </mat-checkbox>
                                </div>

                                <!-- Corresponding Text Input -->
                                <div class="text-input-container" *ngIf="menuItems[i + 1]?.type === 'text'">
                                    <mat-form-field class="compact-input" appearance="outline">
                                        <input matInput [value]="getSettingValue(menuItems[i + 1].key)"
                                            [disabled]="!getSettingValue(item.key)"
                                            (input)="onInputChange(menuItems[i + 1].key, $event)"
                                            placeholder="Enter menu text">
                                    </mat-form-field>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>